/**
 * @module Page-About-Us
 */

import { SECTION_THEME, BANNER_TYPE } from "../../../globals/constants";
import { TypePageAbout } from "../../@types/pageTypes";
import { useEffect, useState } from "react";
import { getAboutData } from "../../../api/about-service";
import { loadScript } from "../../../globals/common-functions";
import banner from '../../../globals/banner.json';
import SectionHome2About from "../../sections/home/home2/home2-about";
import SectionHome2Team from "../../sections/home/home2/home2-team";
import SectionSharedServicesStyle3 from "../../sections/common/shared/services-style3";

import SectionSharedITSolutions from "../../sections/common/shared/it-solutions";
import SectionInnerPageBanner from "../../sections/common/banner";

/**
 * 
 * @returns Markup template for sample page About Us Page
 */
function AboutUsPage() {

    const _aboutDefault: TypePageAbout = {};
    const [results, setResults] = useState(_aboutDefault);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {

        getAboutData((response: TypePageAbout) => {
            setIsFetching(false);
            setResults(response);
            loadScript("js/custom.js")
        })

    }, [isFetching])

    return (
        <>
            {/* INNER PAGE BANNER */}
            <SectionInnerPageBanner _type={BANNER_TYPE.COMPACT} _data={banner.about} />
            {/* INNER PAGE BANNER END */}

            {/* About US SECTION START */}
            {
                results.about &&
                <SectionHome2About
                    _about={results.about!} />
            }
            {/* About US SECTION END */}
            
            {/* IT Solutions SECTION START */}
            {
                results.it &&
                <SectionSharedITSolutions
                _it={results.it!}
            />
            }
            {/* IT Solutions SECTION END */}

            {/*Services SECTION START */}
            {
                results.services &&
                <SectionSharedServicesStyle3 
                _services={results.services!} 
                _theme={SECTION_THEME.LIGHT} />
            }
            {/* Services SECTION END */}

            {/* Team SECTION START */}
            {
                results.team &&
                <SectionHome2Team 
                _team={results.team!} 
                _theme={SECTION_THEME.LIGHT} />
            }
            {/* Team SECTION END */}
        </>
    )
}
export default AboutUsPage;